@let isMiddleOfficeToken = isMiddleOfficeToken$ | async;
@let isDesktop = breakpoints() === "desktop";

<ng-template #mediaContent let-item="item" let-size="size">
  <a [routerLink]="item.url">
    @if (item.video; as video) {
      <div
        [style.height.px]="isDesktop ? size.dh : size.mh"
        [style.width.px]="isDesktop ? size.dw : undefined"
        class="video-wrapper">
        <app-video
          [autoplay]="true"
          [cover]="true"
          [isLoop]="video.isLoop ?? true"
          [isMuted]="video.isMuted ?? true"
          [mp4Url]="video.mp4Url"
          [previewImage]="video.image" />
      </div>
    } @else if (item.image) {
      @let image = item.image;
      <app-image [image]="image" [size]="size" />
    }
    @if (item.legend; as legend) {
      <figcaption [innerHTML]="legend"></figcaption>
    }
  </a>
</ng-template>

@if (data(); as data) {
  @if ((data.items && data.items.length) || isMiddleOfficeToken) {
    <section [style.background-color]="style().backgroundColor | color" class="gallery-layout gallery-layout-5">
      <div class="container">
        <div class="row">
          <div class="col-xs-12 col-lg-7">
            <app-title [titles]="[subtitle()]" />
            <app-title [titles]="[title()]" class="title" />
            @if (isMiddleOfficeToken) {
              <div class="middle-office-buttons">
                <app-middle-office-button [type]="'EDIT_REALISATIONS'" class="middle-office" />
                <app-middle-office-button [type]="'ADD_REALISATION'" class="middle-office" />
              </div>
            }
          </div>
        </div>
        <div class="row">
          <ul class="col-xs-12">
            @if (data.items[0]; as item) {
              <li>
                <figure
                  [ngClass]="{ 'col-lg-5': isDesktop }"
                  [offset]="100"
                  addClass="item-visible"
                  addClassOnView
                  class="item item-0">
                  <ng-container
                    *ngTemplateOutlet="mediaContent; context: { item: item, size: { mh: 211, dw: 486, dh: 313 } }" />
                </figure>
              </li>
            }
            @if (data.items[1]; as item) {
              <li>
                <figure
                  [ngClass]="{ 'col-lg-6 col-lg-offset-6': isDesktop }"
                  [offset]="100"
                  addClass="item-visible"
                  addClassOnView
                  class="item item-1">
                  <ng-container
                    *ngTemplateOutlet="mediaContent; context: { item: item, size: { mh: 400, dw: 588, dh: 720 } }" />
                </figure>
              </li>
            }
            @if (data.items[2]; as item) {
              <li>
                <figure
                  [ngClass]="{ 'col-lg-4 col-lg-offset-1': isDesktop }"
                  [offset]="100"
                  addClass="item-visible"
                  addClassOnView
                  class="item item-2">
                  <ng-container
                    *ngTemplateOutlet="mediaContent; context: { item: item, size: { mh: 218, dw: 384, dh: 247 } }" />
                </figure>
              </li>
            }
            @if (isDesktop) {
              @if (data.items[3]; as item) {
                <li class="row">
                  <figure
                    [offset]="100"
                    addClass="item-visible"
                    addClassOnView
                    class="item item-3 col-lg-9 col-lg-offset-2">
                    <ng-container
                      *ngTemplateOutlet="mediaContent; context: { item: item, size: { dw: 894, dh: 576 } }" />
                  </figure>
                </li>
              }
              @if (data.items[4]; as item) {
                <li class="row">
                  <figure
                    [offset]="100"
                    addClass="item-visible"
                    addClassOnView
                    class="item item-4 col-lg-4 col-lg-offset-8">
                    <ng-container
                      *ngTemplateOutlet="mediaContent; context: { item: item, size: { dw: 384, dh: 470 } }" />
                  </figure>
                </li>
              }
              @if (data.items[5]; as item) {
                <li class="row">
                  <figure [offset]="100" addClass="item-visible" addClassOnView class="item item-5 col-lg-7">
                    <ng-container
                      *ngTemplateOutlet="mediaContent; context: { item: item, size: { dw: 690, dh: 444 } }" />
                  </figure>
                </li>
              }
            }
          </ul>
        </div>
        @if (data.cta && (data.items.length | isShowCta: data.storeItems)) {
          <div class="row center-xs center-lg">
            <div class="col-xs-12 col-lg-12">
              @if (data.cta; as cta) {
                @let styleCta = style().cta;
                <app-button
                  [icon]="styleCta.icon"
                  [label]="cta.label"
                  [size]="styleCta.size"
                  [style]="styleCta.style"
                  [theme]="styleCta.theme"
                  [url]="cta.url"
                  class="button" />
              }
            </div>
          </div>
        }
      </div>
    </section>
  }
}
